export default function (rootElement, data) {
    const numImages = data.numImages;
    const currentSlides = [0, 1, 2];

    rootElement.querySelectorAll(".image-slider").forEach((element, index) => {
        element.querySelectorAll(".image-slider-img")[currentSlides[index]].classList.add("current");
    });

    let prevSliderIndex = -1;
    setInterval(() => {
        const sliderIndex = random(0, 2, [ prevSliderIndex ]);
        const slideIndex = random(0, numImages - 1, currentSlides);

        currentSlides[sliderIndex] = slideIndex;

        rootElement.querySelectorAll(".image-slider")[sliderIndex].querySelectorAll(".image-slider-img.current").forEach(element => {
            element.classList.remove("current");
        });
        
        setTimeout(function () {
            rootElement.querySelectorAll(".image-slider")[sliderIndex].querySelectorAll(".image-slider-img")[slideIndex].classList.add("current");
        }, 1500);

        prevSliderIndex = sliderIndex;
    }, 3000);

    function random(min, max, lockedValues) {
        while (true) {
            const value = Math.floor(Math.random() * ((max - min) + 1)) + min;

            if (lockedValues && lockedValues.includes(value)) {
                continue;
            }

            return value;
        }
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary